import { Label } from '@/components/shadcn/ui/label';
import {
  type ComboboxOption,
  ComboboxTagInput,
  type ComboboxTagInputProps,
} from '@/shared/ui/combobox-tag-input';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormComboboxTagInputProps
  extends Omit<ComboboxTagInputProps, 'value' | 'onChange'> {
  label?: string;
  showErrorMessage?: boolean;
}

export function FormComboboxTagInput({
  label,
  showErrorMessage = true,
  ...props
}: FormComboboxTagInputProps) {
  const field = useFieldContext<string[]>();

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <Label htmlFor={field.name} className="text-sm font-medium">
          {label}
        </Label>
      )}
      <ComboboxTagInput
        value={field.state.value ?? []}
        onChange={(values) => field.handleChange(values)}
        {...props}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}

export type { ComboboxOption };
